export const Errors = {
  INITIALIZE_ERROR: 'INITIALIZE_ERROR',
  FETCH_ROUTES_ERROR: 'FETCH_ROUTES_ERROR',
  NO_ROUTES_ERROR: 'NO_ROUTES_ERROR',
  TOKEN_NOT_TRADABLE: 'TOKEN_NOT_TRADABLE',
  COULD_NOT_FIND_ANY_ROUTE: 'COULD_NOT_FIND_ANY_ROUTE',
  INVALID_REQUEST: 'INVALID_REQUEST',
  ROUTE_PLAN_DOES_NOT_CONSUME_ALL_THE_AMOUNT: 'ROUTE_PLAN_DOES_NOT_CONSUME_ALL_THE_AMOUNT',
} as const;
